import LeadsTable from 'components/LeadsTable'
import useFilters from '@byma/shared/hooks/useFilters'
import dayjs from 'dayjs'
import Link from 'next/link'
import Router, { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import Layout from 'components/Layout'
import useAuth from '@byma/shared/hooks/useAuth'
import useSWR, { useSWRConfig } from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'

export default function Leads() {
    const session = useAuth()

    return (
        <Layout {...{ session }}>
            <div className="flex h-full">
                <div className="w-full">
                    <LeadsTable />
                </div>
            </div>
        </Layout>
    )
}
